export default {
  heading: {
    title: "We’re LGBTQ+.",
    subtitle:
      "In search of an open, safe and respectful world. <span>People.</span>",
    description:
      "To help advance, honor and protect the civil rights of all people, we need to understand the too often grim reality of what our LGBTQ+ colleagues and loved ones face.",
    pdf: "/assets/pdf/P365+_LGBTQ+_Fact_Sheet.pdf",
  },
  challenges: "The Challenges",
  challengesDescription:
    "LGBTQ individuals are 4X more likely to be victims of violence compared with their heterosexual peers, including rape, sexual assault and assaul.<sup>1</sup><br/><br/>The risk of experiencing violence is even higher for undocumented and racial/ethnic minority LGBTQ+ people.",
  challengesStats: [
    {
      percent: "1 in 5",
      sublabel:
        "More than 1 in 5 reported hate crimes are motivated by anti-LGBTQ+ bias.<sup>2</sup>",
    },
    {
      percent: "39%",
      sublabel:
        "Nearly 39% of LGBTQ+ young people reported being forced to do “sexual things” they didn’t want to do.<sup>3</sup>",
    },
    {
      percent: "3 in 10",
      sublabel:
        "Nearly 3 in 10 LGBTQ+ students were bullied at school and nearly 2 in 10 missed school because of safety concerns.<sup>5</sup>",
    },
  ],
  challengesLabeledImages: [
    {
      img: require("@assets/images/toolkits/challenges2.png"),
      sublabel:
        "LGBTQ+ high school students experience higher prevalence of sexual violence and dating violence when compared with heterosexual students.<sup>4</sup>",
    },
    {
      img: require("@assets/images/toolkits/challenges1.png"),
      sublabel:
        "LGBTQ+ adults experience significantly higher prevalence of rape, physical violence and/or stalking when compared with heterosexuals.<sup>6</sup>",
    },
  ],
  mental: "Mental health and substance use disorders",
  mentalList: [
    "1 in 5 U.S. adults experience mental illness<sup>7</sup> – LGBTQ individuals are more than twice as likely as heterosexuals to have a mental health disorder in their lifetime.<sup>8</sup>",
    "LGBTQ+ teens are 6X more likely to experience symptoms of depression than non-LGBTQ+ identifying teens.<sup>9</sup>",
    "The rate of suicide attempts is 4X greater for lesbian, gay, and bisexual youth and 2X greater for questioning youth than that of heterosexual youth.<sup>10</sup>",
    "LGBTQ older adults are more than 2-3X as likely to engage in suicide-related behaviors compared to heterosexual counterparts.<sup>11</sup>",
    "48% of transgender adults considered suicide in the last year, compared to 4 percent of the overall U.S. population.<sup>12</sup>",
    "Transgender individuals who identify as African American/Black, Hispanic/Latino, American Indian/Alaska Native, or multiracial are at increased risk of suicide attempts than white transgender individuals.<sup>13</sup>",
  ],
  disparities: "Disparities",
  disparitiesLabeledImages: [
    {
      img: require("@assets/images/toolkits/disparities1.png"),
      sublabel:
        "Many LGBTQ people have reported experiencing stigma and discrimination when accessing health services, leading some individuals to delay necessary health care or forego it altogether.",
    },
    {
      img: require("@assets/images/toolkits/disparities2.png"),
      sublabel:
        "Approximately 8% of LGBTQ+ individuals and nearly 27% of transgender individuals report being denied needed health care outright.<sup>14</sup>",
    },
    {
      img: require("@assets/images/toolkits/disparities3.png"),
      sublabel:
        "59% of LGBTQ+ people feel they have fewer employment opportunities and 50 percent believe they are paid less than non-LGBTQ+ people.<sup>15</sup>",
    },
  ],
};
